import axios from 'axios';
import { authTypes } from './_actionTypes';
import { to, history} from '../_helpers';
import {alertActions} from './';

const login = (email, password) => async dispatch => {
    // POST login to server
    const [err, res] = await to(axios.post('/api/auth/login',
        {email, password},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));

    // if we get a response dispatch the success. If not dispatch an error
    if(res) {
        dispatch({ type: authTypes.LOGIN_SUCCESS, payload: res.data });
        history.push('/dashboard');
    } else {
        dispatch({ type: authTypes.LOGIN_FAILURE, payload: err.response });
    }
};

const register = ( firstName, lastName, email, password) => async dispatch => {
    // POST register to server
    const [err, res] =  await to(axios.post('/api/users',
        {firstName, lastName, email, password},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));

    if(res) {
        dispatch({ type: authTypes.REGISTER_SUCCESS, payload: res.data });
        history.push('/dashboard');
    } else {
        dispatch({ type: authTypes.REGISTER_FAILURE, payload: err.response.data.error });
    }
}

const sendEmail = (email) => async dispatch => {
    const [err, res] = await to(axios.post('/api/auth/forgot',
        {email},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));
    if(res){
        dispatch(alertActions.success('Email Sent!'));
        dispatch({ type: authTypes.RESET_SENT_SUCCESS, payload: res.data });
        history.push('/login');
    } else {
        dispatch(alertActions.error(err.response.data.error.details[0]));
        dispatch({ type: authTypes.RESET_SENT_FAILURE, payload: err.response.data.error });
    }
}

const resetPassword = (password, token) => async dispatch => {
    const [err, res] = await to(axios.post('/api/auth/reset',
        {password, token},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));
    if(res){
        dispatch(alertActions.success('Password Changed!'));
        dispatch({ type: authTypes.RESET_PASSWORD_SUCCESS, payload: res.data });
        history.push('/login');
    } else {
        dispatch(alertActions.error('Error. Please try again!'));
        dispatch({ type: authTypes.RESET_PASSWORD_FAILURE, payload: err.response.data.error });
    }
}
export const authActions = {
    login, register, sendEmail, resetPassword
};


// WEBPACK FOOTER //
// ./src/actions/auth.actions.js